import { access_visibility_offering_types } from "constants/schedule";
import { access_visibility_address_type } from "./ShareRecording.constant";

/**
 * Helper utility to determine whether customer recording availability section should be displayed.
 *
 * @param {Object} params
 * @param {string|number} params.type - Offering type
 * @param {string|number} params.addressType - Location/Address type
 * @returns {boolean}
 */
export const checkShowRecordingAvailability = ({ type, addressType } = {}) => {
  return (
    access_visibility_offering_types.includes(type) &&
    access_visibility_address_type.includes(addressType)
  );
};
